import React from 'react';
import Icon from '../../Icon';

const MobileNavigationDropdownItem = ({
  name,
  url,
  code,
  region,
  onLinkClick,
}: {
  name: string;
  url: string;
  code?: string;
  region?: string;
  onLinkClick?: any;
}) => {
  return (
    <li className="flex justify-between text-lg font-bold">
      <a
        className="flex-1 p-4 pl-6 text-md lowercase text-white [&:first-letter]:capitalize"
        href={url}
        onClick={(e) => {
          if (onLinkClick) {
            onLinkClick(e, code, url);
          }
        }}
      >
        {region && region != '' && (
          <Icon
            name={`flag-` + region.toLowerCase()}
            className="mr-1.5 overflow-hidden rounded-full"
          />
        )}
        {name}
      </a>
    </li>
  );
};
export default MobileNavigationDropdownItem;
